<template>
    <span class="project-image-label">KI-generiertes Bild</span>
</template>

<script>
export default {
    name: 'ProjectImageLabel'
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectImageLabel.vue